<!-- 一键加油 -->
<template>
  <div>
    <site ref="site" @get_site_id="get_site_id" />
    <card ref="card" :s_id="s_id"  @get_card_data="get_card_data" @get_recharge="get_recharge" />

    <van-field v-if="card_data" :class="gun_num == '' ? 'gun_no' : 'gun_input'" v-model="gun_num" label="油枪号：" left-icon="smile-o" readonly size="large" placeholder="输入油枪号查询订单"  @click-input="show_keyboard = true">
    <template v-if="order_data.length > 0" #button>
      <van-button type="info" size="small" @click ="on_show_order">重选订单</van-button>
    </template>
    </van-field>

    <div class="p_body">
      <!-- 订单信息 -->
      <van-cell-group v-if="order" title="订单信息">
        <van-cell title="交易时间：" :value="order.date" />
        <van-cell title="订单明细：" :value="order.oil.oil_name + ' ' + order.oil.liter + 'L x ' + order.oil.price.toFixed(2) + '元/L'" />
        <van-cell value-class="money" title="应收总额:" :value="order.total" />

        <!-- 优惠信息 -->
        <van-cell v-show="order.p.level_money > 0" value-class="money" title="会员优惠:" :value="'- ' + order.p.level_money.toFixed(2)" />
        <van-cell v-show="order.p.disc_off_money > 0" value-class="money" title="限时优惠:" :value="'- ' + order.p.disc_off_money.toFixed(2)" />

      </van-cell-group>

      <van-submit-bar label="需付：" :price="show_money()" button-text="支付订单" :loading="ifOn" :disabled="ifOn || !order" @submit="pay()" />

      <!-- 数字键盘 -->
      <van-number-keyboard
        safe-area-inset-bottom
        :hide-on-click-outside="false"
        theme="custom"
        :extra-key="['x']"
        :show="show_keyboard"
        close-button-text="查询"
        @blur="show_keyboard = false"
        @input="keyboard_on"
        @delete="keyboard_del"
        @hide="on_sel_order"
      />

      <!-- 选择订单 -->
      <van-popup class="order" v-model="show_order" position="bottom" round @click-overlay="show_keyboard = true">
        <div class="tit">选择订单</div>

        <div class="order_list">
            <van-cell-group class="list" v-for="(val, key) in order_data" :key="key" @click="on_order(val)">
              <van-cell :title="val.date" :value="val.money + ' 元'" value-class="money" />
              <van-cell title="订单明细：" :value="val.oil.oil_name + ' ' + val.oil.liter + 'L * ' + val.oil.price.toFixed(2) + '元/L'" />
            </van-cell-group>
        </div>
      </van-popup>

      <!-- 支付方式 -->
      <van-radio-group v-model="pay_type" v-if="order" :disabled="!if_card_pay">
        <van-cell-group title="请选择您的支付方式">
          <van-cell title="微信支付"  class="pay_method">
            <template #icon>
              <van-radio name="1" />
            </template>
          </van-cell>

          <van-cell v-if="if_card_pay"  title="油卡支付" class="pay_method">
            <template #icon>
              <van-radio name="2"/>
            </template>
          </van-cell>

          <span v-else>
            <van-cell v-if="if_recharge" title="油卡支付 (余额不足)" value="充值油卡" class="pay_method" is-link @click="$refs.recharge.show(card_data)">
              <template #icon>
                <van-radio name="2" />
              </template>
            </van-cell>
            <van-cell v-else title="油卡支付 (余额不足)" class="pay_method" >
            <template #icon>
              <van-radio name="2"/>
            </template>
          </van-cell>
          </span>

        </van-cell-group>
      </van-radio-group>
    </div>
    <!-- 子组件 -->
    <recharge ref="recharge" @up_data="$refs.card.get_data()" @show_msg="show_msg" />
    <msg ref="msg" @up_data="$refs.card.get_data()" />
    <pay ref="pay" @result="pay_result" />
  </div>
</template>

<style lang="scss" scoped>
  .money {
    font-size: 16px;
    color: #ee0a24;
    font-weight: 500;
  }

  .p_body {
    max-height:calc(100vh - 270px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .order {
    background: #f6f6f6;
    padding-bottom: 20px;

    .tit {
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 16px;
      padding: 11px 20px;
      border-bottom: 2px solid #409EFF;
      background-color: #fff;
    }

    .list {
      margin: 10px 15px;
    }

    .order_list {
      max-height:calc(100vh - 250px);
      overflow-x: hidden;
      overflow-y: auto;
    }
  }

  .gun_no {
    margin-top: 5px;
  }

  .gun_input {
    margin-top: 5px;
    font-size: 18px;
  }

  .lock span {
    color: red;
  }
  .pay_method .van-cell__title {
    margin-left: 10px;
  }
</style>

<script>
import site from '@/components/oiling/site'
import card from '@/components/oiling/card'
import recharge from '@/components/card/recharge'
import msg from '@/components/card/msg'
import pay from '@/components/pay'

export default {
  name: 'oiling',
  components: {site, card, recharge, msg, pay},
  data () {
    return {
      ifOn: false,
      s_id: null,
      card_data: null,
      show_keyboard: true,
      gun_num: '',
      order: null,
      pay_money: 0,
      show_order: false,
      order_data: [],
      iflock: false,
      pay_type: '1',
      if_card_pay: true,
      if_recharge: false
    }
  },
  created () {
    this.$refs.site.get_data()
  },
  methods: {

    // 获取站点id
    get_site_id (val) {
      this.s_id = val
      this.del_order()
      this.$refs.card.get_data()
    },

    // 获取卡数据
    get_card_data (data) {
      this.$root.loadingAll = false
      this.card_data = data
      if (data) {
        this.set_level_money()
        this.set_pay()
      }
    },

    // 数字键盘输入
    keyboard_on (val) {
      // 清空
      if (val === 'x') {
        this.gun_num = ''
        return
      }

      // 过滤错误输入
      if (this.gun_num.length === 0 && val === 0) {
        return
      }

      this.gun_num += val.toString()
    },

    // 数字键盘删除
    keyboard_del () {
      this.gun_num = this.gun_num.substr(0, this.gun_num.length - 1)
    },

    // 数字键盘点击查询
    on_sel_order () {
      // 判断输入
      if (this.gun_num === '') {
        this.show_keyboard = true
        return this.$notify({ type: 'warning', message: '请正确输入油枪号' })
      }
      this.sel_order(() => {})
    },

    // 查询订单
    sel_order (successfn) {
      this.ax(this, 'web_sel_payment', {s_id: this.s_id, gun_num: this.gun_num}, (res) => {
        this.del_order()
        if (res.err_num === 0) {
          // 无订单
          if (res.data.length === 0) {
            this.show_keyboard = true
            successfn(false)
            return this.$notify({ type: 'warning', message: '无订单，油枪号是否正确' })
          }

          this.order_data = res.data
          if (res.data.length > 1) {
            // 多订单
            this.show_order = true
          } else {
            // 单订单
            this.on_order(res.data[0])
          }
          this.show_keyboard = false
          successfn(true)
        }
      }, 'all')
    },

    // 选中订单
    on_order (order) {
      this.show_order = false
      this.order = order
      this.pay_money = this.order.money
      this.set_level_money()
      this.set_pay()
    },

    // 重选订单
    on_show_order () {
      this.sel_order((res) => {
        if (!res) { return } // 无订单终止
        if (this.order_data.length !== 1) {
          this.show_order = true
        } else {
          this.$notify({ type: 'warning', message: '该枪号没有更多订单' })
        }
      })
    },

    // 清空订单数据
    del_order () {
      this.order = null
      this.order_data = []
      this.pay_money = 0
    },

    // 计算会员优惠
    set_level_money () {
      if (this.order && this.card_data) {
        this.ax(this, 'web_set_level', {order_id: this.order.order_id, card_id: this.card_data.card_id}, (res) => {
          if (res.err_num === 0) {
            this.order.p.level_money = res.data.level_money
            this.order.p.money = res.data.level_money
            this.pay_money = parseFloat((this.order.money - res.data.level_money).toFixed(2))
          }
        })
      }
    },

    // 计算订单显示金额
    show_money () {
      if (this.order) {
        return parseFloat(this.pay_money) * 100
      } else {
        return 0
      }
    },

    // 判断油品限制
    ver_oil_type () {
      // 无卡
      if (!this.card_data) {
        return true
      }

      // 有卡
      let ver = true
      // 判断油卡类型
      if (this.card_data.chip_id === null) {
        // 虚拟卡
        if (parseInt(this.card_data.oil_kind) !== parseInt(this.order.oil.oil_kind)) {
          ver = false
        }
      } else {
        // 实体卡
        if (this.card_data.limit_oil !== '' && parseInt(this.card_data.limit_oil) !== parseInt(this.order.oil.type)) {
          ver = false
        }
      }

      if (!ver) {
        this.$notify({ type: 'warning', message: '该卡油品限制，请换油卡支付' })
      }
      return ver
    },

    // 计算可选支付方式
    set_pay () {
      if (!this.order) { return }
      if (parseFloat(this.card_data.money) >= parseFloat(this.order.money)) {
        this.if_card_pay = true
        this.pay_type = '2'
      } else {
        this.if_card_pay = false
        this.pay_type = '1'
      }
    },

    // 显示编辑信息
    show_msg () {
      this.$refs.msg.show(this.card_data)
    },

    // 支付订单
    pay () {
      // 组装公共数据
      let data = {
        order_id: this.order.order_id,
        card_id: this.card_data.card_id
      }

      // 判断油品限制
      if (!this.ver_oil_type()) { return }
      // 判断有卡支付时选择支付方式
      if (this.pay_type === '1') {
        this.online_pay(data)
      } else {
        this.card_pay(data)
      }
    },

    // 油卡支付
    card_pay (data) {
      this.ax(this, 'web_card_pay', data, (res) => {
        if (res.err_num === 0) {
          this.del_order()
          this.$refs.card.get_data()
          this.$notify({ type: 'success', message: '支付成功' })
        }
      }, 'all')
    },

    // 线上支付
    online_pay (data) {
      data.into_type = 1
      if (this.card_data) {
        // 用卡
        this.ax(this, 'up_p_level', data, (res) => {
          if (res.err_num === 0) {
            this.$refs.pay.show({
              type: 1,
              order_id: data.order_id
            })
          }
        }, 'on')
      } else {
        // 无卡
        this.$refs.pay.show({
          type: 1,
          order_id: data.order_id
        })
      }
    },

    // 线上支付结束
    pay_result (res) {
      if (res.res || res.type === 1) {
        this.del_order()
      }
    },

    // 判断是否可以充值
    get_recharge (val) {
      this.if_recharge = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oiling/oiling.vue